export default {
	data() {
		return {
			contactsCardType: 'private',
			contactsCardChoicer: 'bank'
		}
	},
}
